import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import NProgressBar from 'components/NProgress';
import injectReducer from 'utils/injectReducer';
import { makeSelectProgressBarStatus } from './selectors';
import reducer from './reducer';

function ProgressBar(props) {
  // eslint-disable-line react/prefer-stateless-function

  return <NProgressBar loading={props.loading} />;
}

ProgressBar.propTypes = {
  loading: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  loading: makeSelectProgressBarStatus(),
});

const withConnect = connect(mapStateToProps);
const withReducer = injectReducer({ key: 'progressBar', reducer });

export default compose(
  withReducer,
  withConnect
)(ProgressBar);



// WEBPACK FOOTER //
// ./app/containers/ProgressBar/index.js